export enum MessageType {
    ALERT = 'alert',
    NOTICE = 'notice',
}
